import { ErrorBoundary } from 'react-error-boundary'

import { DeliveryForecastDespatchAdvice } from '../features/delivery-forecast-despatch-advice/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const DeliveryForecastDespatchAdvicePage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <DeliveryForecastDespatchAdvice />
    </ErrorBoundary>
  )
}
